import type { Assignment } from "../api/assignments/Assignments.domain";

/**
 * Returns whether activities differ between the original and current assignment.
 */
export function haveActivitiesChanged(original: Assignment | null, current: Assignment): boolean {
  if (!original) return false;

  const origLen = original.activities?.length ?? 0;
  const currLen = current.activities?.length ?? 0;
  if (origLen !== currLen) return true;

  if (!current.activities?.length || !original.activities?.length) {
    return false;
  }

  return JSON.stringify(current.activities) !== JSON.stringify(original.activities);
}
